import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import hotkeys from "hotkeys-js";
  import { computed, inject, onMounted, onUnmounted } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HotKeysService',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const emitter = inject("emitter");

  const onceTwiceSoldHotKey = computed(() => {
    return parseValues(auctionStore.liveSettings.once_twice_sold_hot_key);
  });
  const bookBidHotKey = computed(() => {
    return parseValues(auctionStore.liveSettings.book_bid_hot_key);
  });
  const bookBidFirstHotKey = computed(() => {
    return parseValues(auctionStore.liveSettings.book_bid_first_hot_key);
  });
  const passLotHotKey = computed(() => {
    return parseValues(auctionStore.liveSettings.pass_lot_hot_key);
  });
  const retractBidHotKey = computed(() => {
    return parseValues(auctionStore.liveSettings.retract_bid_hot_key);
  });

  onMounted(() => {
    bindHotKeys();
  });

  onUnmounted(() => {
    unbindHotKeys();
  });

  const bindHotKeys = () => {
    hotkeys("*", { scope: "auction-hot-keys", element: document }, callback);
    hotkeys.filter = (event) => {
      hotkeys.setScope(event.target.dataset.scope || "auction-hot-keys");
      return true;
    };
  };

  const unbindHotKeys = () => {
    hotkeys.unbind("*", "auction-hot-keys", callback);
  };

  const callback = (event) => {
    let hotKey = null;

    if (!auctionStore.isLockedButtons && auctionStore.user?.is_admin) {
      const pressedKeysCount = hotkeys.getPressedKeyCodes().length;

      if (
        onceTwiceSoldHotKey.value?.length === pressedKeysCount &&
        onceTwiceSoldHotKey.value?.every((code) => hotkeys.isPressed(code))
      ) {
        hotKey = "hot-key:once-twice-sold";
      } else if (
        bookBidHotKey.value?.length === pressedKeysCount &&
        bookBidHotKey.value?.every((code) => hotkeys.isPressed(code))
      ) {
        hotKey = "hot-key:book-bid";
      } else if (
        bookBidFirstHotKey.value?.length === pressedKeysCount &&
        bookBidFirstHotKey.value?.every((code) => hotkeys.isPressed(code))
      ) {
        hotKey = "hot-key:book-bid-first";
      } else if (
        passLotHotKey.value?.length === pressedKeysCount &&
        passLotHotKey.value?.every((code) => hotkeys.isPressed(code))
      ) {
        hotKey = "hot-key:pass-lot";
      } else if (
        retractBidHotKey.value?.length === pressedKeysCount &&
        retractBidHotKey.value?.every((code) => hotkeys.isPressed(code))
      ) {
        hotKey = "hot-key:retract-bid";
      }

      if (hotKey) {
        event.preventDefault();
        event.stopPropagation();
        emitter?.emit(hotKey);
        return false;
      }
    }

    return true;
  };

  const parseValues = (value) => {
    if (value) {
      if (typeof value == "string") {
        return JSON.parse(value);
      } else {
        return value;
      }
    }
    return [];
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})